/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- TRIVIA ANALYTICS - AVERAGE IN VIEW REPORT : STYLES --------------- ++++++++++ */
export default {
    avginviewreport: {
    }
};
